import React from 'react';
import { Badge } from '@shared/ui/badge';
import { StepHelpers } from '@shared/components/Stepper';
import { Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const SelectedAccountsBanner = ({ stepHelpers }: { stepHelpers?: StepHelpers }) => {
  const { t } = useTranslation();
  // SelectAccountsStep is always step 0 when multiAccount is enabled
  const step0Data = stepHelpers?.getStepData(0) || {};
  const selectedAccounts = step0Data.selectedAccounts || [];
  
  if (selectedAccounts.length === 0) return null;

  return (
    <div className="mb-6 bg-blue-50/50 border border-blue-100 rounded-xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <Building2 className="w-4 h-4 text-blue-600" />
        <h4 className="text-sm font-semibold text-blue-900">{t("Selected Accounts ({{count}})", { count: selectedAccounts.length })}</h4>
      </div>
      <div className="flex flex-wrap gap-2">
        {selectedAccounts.map((acc: any) => (
          <Badge key={acc.id} variant="secondary" className="bg-white border-blue-200 text-blue-700 font-medium px-3 py-1">
            {acc.consumerNo}
          </Badge>
        ))}
      </div>
    </div>
  );
};
